<button #target (mouseleave)="handleMouseLeave($event)" (mouseenter)="handleMouseEnter($event)"
    class="circle-btn{{size ? ' -size-'+size : ''}}{{feel ? ' -feel-'+feel : ' -feel-brand-accent'}}"
    (click)="handleButtonClick($event, target)"
    [ngClass]="{'is-disabled': disabled, 'is-hovering': isHovering, 'is-active': isActive && !disabled, '-no-hover-shadow': !hoverShadow}"
    [disabled]="disabled">

    <shared-icon class="circle-btn__icon-obj" [icon]="icon" *ngIf="icon && (!isHovering && iconHover || !iconHover)">
    </shared-icon>

    <shared-icon class="circle-btn__icon-obj" [icon]="iconHover" *ngIf="iconHover && isHovering"></shared-icon>
    <ng-content></ng-content>
</button>
